/**
 * Ortam adreslerinin TEK kaynagi.
 *
 * Eskiden ortam farki BRANCH ile yonetiliyordu: `master`ta butun adresler `.com`,
 * test branch'inde ayni adresler elle `.app` yapilmisti -- on kadar dosyada.
 * `call.js`'teki "// .app olarak degistirilmeli" notu o elle takasin talimatiydi.
 *
 * Bunun iki bedeli vardi. Her merge farki yanlis yone tasima riski tasiyordu, ve
 * bir kez tasidi: uretim build'i test host'larina bakiyordu (bu dosyadaki eski
 * ConfigProd dahil). Ikincisi daha sinsiydi -- `craco build` her iki deploy'da da
 * `NODE_ENV=production` uretiyor, yani eski secici hicbir zaman ConfigTest'i
 * secmiyordu; test deploy'u da ConfigProd'u kullaniyordu ve birileri "test
 * calissin" diye ConfigProd'u `.app`e cevirmisti.
 *
 * Artik kaynakta baska hicbir yerde alan adi gecmiyor, yani iki branch ayni kodu
 * tasiyor. Ortam asagidaki `detectEnv`ten geliyor.
 */

/**
 * Ortam, sayfanin SERVIS EDILDIGI adresten okunuyor -- build'den degil.
 *
 * Ilk surum ortami build komutuna bagliyordu (`yarn build` -> production,
 * `yarn build:test` -> test). Test sunucusunda `yarn build` calistirilinca test
 * build'i uretim adreslerini aldi ve `/api/me` canli makinaya gitti. Hangi komutun
 * calistirildigi deploy yontemine bagli ve bu projede o yontem tutarli degil
 * (test'in pm2 config'i yanlis repoyu gosteriyor), yani build'e guvenmek ayni hatayi
 * bekleyen bir tuzakti.
 *
 * Uygulama `playable-old.playablefactory.com` ya da `.app`ten aciliyor; hangi
 * ortamda oldugunu kendi adresi kesin olarak soyluyor ve hicbir build adimi bunu
 * yanlis yapamaz.
 *
 * `REACT_APP_ENV` yalnizca adres bilinen iki alandan biri degilken kullaniliyor
 * (localhost'ta gelistirme). Orada da varsayilan TEST: yanlis tahminin ucuz yonu.
 */
function detectEnv() {
	const host = typeof window !== "undefined" && window.location ? window.location.hostname : "";
	if (host === "playablefactory.com" || host.endsWith(".playablefactory.com")) return "production";
	if (host === "playablefactory.app" || host.endsWith(".playablefactory.app")) return "test";
	return process.env.REACT_APP_ENV === "production" ? "production" : "test";
}

const ENV = detectEnv();

/**
 * Butun adresler `https://<alt>.playablefactory.<tld>` kalibinda; degisen tek sey
 * tld. Config'in tamaminin tek bir satira inmesinin sebebi bu.
 */
const DOMAIN = ENV === "production" ? "playablefactory.com" : "playablefactory.app";

const at = (subdomain) => `https://${subdomain}.${DOMAIN}`;

const HOME = at("home");
const PLAYABLE = at("playable");
const PLAYABLE_OLD = at("playable-old");
/**
 * Editorun statik dosyalari (loader, interactive end card, network analytics)
 * ORTAMDAN BAGIMSIZ: iki ortam da uretimdeki ayni kopyayi kullaniyor.
 *
 * `cdn.dashboard.playablefactory.app` diye bir host yok, DNS'te bile cozulmuyor.
 * Bu adresler eski config'de test build'inde de `.com`du (her build ConfigProd'u
 * kullaniyordu). "Her adres ayni kalipta" varsayimi burada yanlisti ve test
 * editoru `interactive-ec.js`i bulamiyordu.
 */
const SHARED_DASHBOARD_CDN = "https://cdn.dashboard.playablefactory.com";
const SHARED_ANALYTICS_URL = "https://home.playablefactory.com/files/.common/networks/misc.js";

const Config = {
	ENV,
	DOMAIN,

	/** Cerez alan adi. Bastaki nokta sart: alt alanlarin hepsini kapsiyor. */
	COOKIE_DOMAIN: `.${DOMAIN}`,

	HOME,
	PLAYABLE,
	/** Bu uygulamanin kendi host'u; dosya adresleri buna gore kuruluyor. */
	PLAYABLE_OLD,
	ACCOUNT: at("account"),
	LOGIN: `${HOME}/login`,
	API: `${PLAYABLE_OLD}/api`,

	ANALYTICS_URL: SHARED_ANALYTICS_URL,
	LOADER_CSS_URL: `${SHARED_DASHBOARD_CDN}/loader.css`,
	LOADER_HTML_URL: `${SHARED_DASHBOARD_CDN}/loader.html`,
	INTERACTIVE_END_CARD_URL: `${SHARED_DASHBOARD_CDN}/interactive-ec.js`,

	/**
	 * Eski adlar, yalnizca geriye uyum icin. `NEXT_PUBLIC_` oneki bu projede hicbir
	 * sey ifade etmiyor -- burasi Next.js degil, CRA. Yeni kod yukaridakileri
	 * kullansin.
	 */
	NEXT_PUBLIC_GEARBOX_PLAYABLE: PLAYABLE,
	NEXT_PUBLIC_GEARBOX_API: `${PLAYABLE_OLD}/api`,
	NEXT_PUBLIC_GEARBOX_PLAYABLE_EDIT_OLD: PLAYABLE_OLD,
};

export { Config };
export default Config;
